import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { H4 } from 'UIComponents/elements/headings';

const ForbiddenError = ({
  className
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('missing-content-error', className),
  "data-test-id": "missing-content-error",
  illustration: "lock",
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.forbidden.heading"
    })
  }),
  type: "403",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.forbidden.subheading"
    })
  }), /*#__PURE__*/_jsx(UIRouterButton, {
    to: "/",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.missingContent.button"
    })
  })]
});

export default ForbiddenError;